import { Text } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { CASE_2, CASE_3, CASE_4, CASE_5, CASE_6 } from '../ModalSmsSender'

const Description = ({ isTrial, items, caseState }) => {
  const intl = useIntl()

  const getDescription = () => {
    switch (caseState) {
      case CASE_2:
      case CASE_3:
      case CASE_5:
      case CASE_6:
        return 'Load.SmsAliasSelector.ModalSenderDescrAliasNoEmptyNew'
      case CASE_4:
        return 'Load.WarningAlias.ModalSendersParagraphTrialIntl'
      default:
        break
    }
  }

  return (
    <span>
      <Text htmlElement='span'>
        {intl.formatMessage(
          { id: getDescription() },
          {
            linebreak: <br />,
            strong: (str) => <strong>{str}</strong>
          }
        )}
      </Text>
    </span>
  )
}

Description.propTypes = {
  isTrial: PropTypes.bool,
  items: PropTypes.array,
  caseState: PropTypes.number
}

export default Description
